import { withInstall } from "../utils/index.mjs";
import _CheckboxGroup from "./CheckboxGroup.mjs";
const CheckboxGroup = withInstall(_CheckboxGroup);
var stdin_default = CheckboxGroup;
import { checkboxGroupProps } from "./CheckboxGroup.mjs";
export {
  CheckboxGroup,
  checkboxGroupProps,
  stdin_default as default
};
